import './thecliffshotel1/style';
import FormStructure from './thecliffshotel1/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js